var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 50,
    viewBox: "0 0 41 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 41.9172V42.8906C14.2217 46.2639 16.9577 48.9999 20.3337 48.9999V48.9999C23.7097 48.9999 26.4457 46.2639 26.4457 42.8879V41.9146",
    stroke: "#FF4E83",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2213 8.33601V5.888C25.2213 3.18934 23.0347 1 20.3333 1V1C17.632 1 15.4453 3.18934 15.4453 5.888V8.33601",
    stroke: "#FF4E83",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83467 20.1681V20.1681C5.83467 13.4935 11.2453 8.08545 17.9173 8.08545H22.752C29.4267 8.08545 34.8347 13.4961 34.8347 20.1681V20.1681V27.6268C34.8347 29.0401 35.3974 30.3975 36.3974 31.3975L38.1067 33.1068C39.1067 34.1068 39.6694 35.4641 39.6694 36.8775V36.8775C39.6694 39.6615 37.4134 41.9175 34.6294 41.9175H6.04C3.256 41.9175 1 39.6615 1 36.8775V36.8775C1 35.4641 1.56267 34.1068 2.56267 33.1068L4.272 31.3975C5.272 30.3975 5.83467 29.0401 5.83467 27.6268V20.1681Z",
    stroke: "#FF4E83",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19101 21.0814C9.19101 15.6701 13.3487 11.2856 18.4756 11.2856H22.1906C27.3196 11.2856 31.4752 15.6722 31.4752 21.0814L31.3174 26.7686C31.3174 27.9144 31.2389 29.1861 31.6832 30.1698C31.6832 30.1698 32.2611 31.8209 33.3177 32.8941C34.3744 33.9673 36.7895 35.5144 36.1554 37.4168C35.6133 39.0431 34.4974 38.9875 31.3176 38.9875H9.34895C7.20966 38.9875 4.77434 39.2705 4.27469 37.2131C3.87369 35.5619 5.22455 34.7744 6.13631 33.9553L8.2597 31.5701C9.02812 30.7593 9.19101 28.2742 9.19101 27.1284V21.0814Z",
    fill: "url(#paint0_linear_9465_23060)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9465_23060",
    x1: 5.04376,
    y1: 39.2737,
    x2: -1.31452,
    y2: 17.3051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00221239,
    stopColor: "#FF4E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBellIcon);
export default __webpack_public_path__ + "static/media/red-bell-icon.a811169c86e71f091345bbeb5fc6ec0e.svg";
export { ForwardRef as ReactComponent };